import { useCallback, useEffect, useState } from 'react';

let globalSetOpen: React.Dispatch<React.SetStateAction<boolean>> | null = null;

export function useGlobalSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    globalSetOpen = setOpen;
    return () => { globalSetOpen = null; };
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const isShortcut = (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k';
      if (!isShortcut) return;
      event.preventDefault();
      setOpen((prev) => !prev);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, setOpen };
}

export function openGlobalSearch() {
  globalSetOpen?.(true);
}
